import {Typography, TypographyProps} from '@material-ui/core'

type Props = TypographyProps & {
  children: React.ReactNode
  style?: any
}
const Subtitle2: React.FC<Props> = (props: Props) => {
  let color = props.color
  if (!color) {
    color = 'textPrimary'
  }
  return (
    <Typography variant="subtitle2" {...props} color={color} style={{...props.style}}>
      {props.children}
    </Typography>
  )
}

export default Subtitle2
